if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // Click listener for navigation buttons
        this.addEventListener('click', (event) => {
          if (event.target.closest('.product-media-modal__nav-btn--prev')) {
            this.navigateMedia(-1);
          } else if (event.target.closest('.product-media-modal__nav-btn--next')) {
            this.navigateMedia(1);
          }
        });

        // Keyboard arrow navigation
        window.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            this.navigateMedia(-1);
          } else if (event.key === 'ArrowRight') {
            this.navigateMedia(1);
          }
        });

        // Touch swipe gesture support
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].screenX;
        }, { passive: true });

        this.addEventListener('touchend', (event) => {
          this.touchEndX = event.changedTouches[0].screenX;
          this.handleSwipe();
        }, { passive: true });
      }

      handleSwipe() {
        const threshold = 50; // minimum swipe distance in px
        if (this.touchEndX < this.touchStartX - threshold) {
          this.navigateMedia(1); // Swiped left -> Next
        } else if (this.touchEndX > this.touchStartX + threshold) {
          this.navigateMedia(-1); // Swiped right -> Previous
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        if (allMedia.length <= 1) return;

        const currentActive = this.querySelector('[data-media-id].active');
        let currentIndex = allMedia.indexOf(currentActive);
        if (currentIndex === -1) currentIndex = 0;

        let nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = allMedia.length - 1;
        if (nextIndex >= allMedia.length) nextIndex = 0;

        const nextMedia = allMedia[nextIndex];
        const nextMediaId = nextMedia.getAttribute('data-media-id');

        this.openedBy = {
          getAttribute: () => nextMediaId
        };
        this.showActiveMedia();
      }
    }
  );
}
